<template>
  <div>
    <v-card flat tile class="body-2" :color="joinColor">
      <v-container grid-list-md fluid>
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 md4>
            <div>{{ className }}</div>
            <div class="caption grey--text">{{ filialName }}</div>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <div>
          <span class="caption green lighten-4 mr-1" v-if="join.stats.visits>0">
            Был {{ join.stats.visits }} раз</span>
              <span class="caption orange lighten-4 mr-1" v-if="join.stats.visits==0">Не был
          </span>

              <span class="caption green lighten-4 mr-1" v-if="nextRecordDate">
            Запись на {{ nextRecordDate }}
          </span>
              <span class="caption red lighten-4 mr-1" v-if="!nextRecordDate">
            Не записан
          </span>
            </div>
            <v-btn v-if="!showLessons" text
                   color="accent" class="mt-2" @click="showLessons=true">
              Показать занятия
            </v-btn>
            <v-btn v-if="showLessons" text
                   color="accent" class="mt-2" @click="showLessons=false">
              Скрыть занятия
            </v-btn>
          </v-flex>
          <v-flex xs12 md3>
            <div v-if="joinClass.payType==='full'">
              Внесено
              <span class="green--text">{{ join.stats.totalPayed.toLocaleString(lang) }}</span>
              / <money color-class="red--text" :sum="join.price - join.stats.totalPayed"></money>
            </div>
            <div v-if="joinClass.payType==='lessons'">
              Внес <money color-class="green--text" :sum="join.stats.totalPayed"></money>
            </div>
            <div v-for="item of debtInvoices" :key="item.id">
                <span :class="item.color" class="caption">След. платеж
                  <money color-class="red--text" :sum="item.nextSum"></money> до {{ item.payDate }}
                </span>
            </div>
            <div v-for="sub of daysLeftSubscriptions" :key="'dl' + sub.id" class="caption">
            <span
              class="caption lighten-4"
              :class="(sub.visitCount - sub.visitedCount)<3?'red':'green'">
              Осталось {{ sub.visitCount - sub.visitedCount }} зан.
            </span>
            </div>
            <div v-for="sub of debtSubscriptions" :key="sub.id" class="caption">
              <div v-for="item of sub.debtInvoices" :key="item.id">
                <span :class="item.color" class="caption"> Долг
                  <money color-class="red--text" :sum="item.debt"></money> до {{ item.payDate }}
                </span>
              </div>
            </div>
            <div class="caption">
              <span v-if="join.stats.nonPayedLessons>0" class="caption red lighten-4">
              {{ join.stats.nonPayedLessons }} зан. в долг
            </span>
            </div>
            <div v-if="showCreatePaymentButton">
              <v-btn text color="accent"
                     @click="showPaymentPanel(...showCreatePaymentButton)">
                + Платеж/Аб-т
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs12 md2 class="text-left text-md-center">
            <div class="primary--text" v-if="join.status === 'study'">Занимается</div>
            <div class="red--text" v-if="join.status === 'over'">Завершил/отказ</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <user-join-lessons v-if="showLessons" :join="join"></user-join-lessons>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapMutations } from 'vuex';
import { getClassColor, getClassName } from '@/lib/classHelpers';
import UserJoinLessons from './UserJoinLessons.vue';
import Money from '@/components/Money';

export default {
  name: 'UserJoinCard',
  components: { Money, UserJoinLessons },
  props: ['join'],
  data: () => ({
    showLessons: false,
  }),
  computed: {
    className() {
      return getClassName(this.join.classId);
    },
    classPayType() {
      const cl = this.classes.find(c => c.id === this.join.classId);
      return cl.payType;
    },
    joinClass() {
      return this.classes.find(cl => cl.id === this.join.classId);
    },
    filialName() {
      const cl = this.classes.find(c => c.id === this.join.classId);
      if (!cl) {
        return null;
      }
      const filial = this.filials.find(f => f.id === cl.filialId);
      if (filial) {
        return filial.name;
      }
      return null;
    },
    joinColor() {
      return getClassColor(this.join.classId);
    },
    debtColor() {
      const { remindDate } = this.join;
      if (!remindDate) {
        return null;
      }
      const diff = -moment().diff(remindDate, 'day');
      if (diff < 0) {
        return 'red lighten-4';
      }
      if (diff < 3) {
        return 'orange lighten-4';
      }
      return 'light-blue lighten-4';
    },
    debtDate() {
      const { remindDate } = this.join;
      return remindDate ? moment(remindDate).format('DD.MM') : null;
    },
    nextRecordDate() {
      return this.join.stats.nextRecord
        ? moment(this.join.stats.nextRecord).format('DD.MM') : null;
    },
    subscriptions() {
      return this.userSubscriptions
        .filter(sub => sub.classIds.includes(this.join.classId) && sub.statusId !== 4);
    },
    daysLeftSubscriptions() {
      return this.subscriptions.filter(sub => sub.visitCount - sub.visitedCount < 10);
    },
    debtSubscriptions() {
      return this.subscriptions
        .filter(sub => (sub.payed < sub.price) && sub.remindDate)
        .map((sub) => {
          const newSub = { ...sub };
          if (sub.invoices) {
            newSub.debtInvoices = newSub.invoices
              .filter(invoice => invoice.price > invoice.payed)
              .map(invoice => ({
                color: this.getDebtColor(invoice.payUntil),
                payDate: moment(invoice.payUntil).format('DD.MM'),
                debt: invoice.price - invoice.payed,
                ...invoice,
              }));
          }
          return newSub;
        });
    },
    debtInvoices() {
      if (this.join.invoices) {
        return this.join.invoices
          .filter(invoice => invoice.price > invoice.payed)
          .map(invoice => ({
            color: this.getDebtColor(invoice.payUntil),
            payDate: moment(invoice.payUntil).format('DD.MM'),
            debt: invoice.price - invoice.payed,
            ...invoice,
          }));
      }
      return [];
    },
    showCreatePaymentButton() {
      if (!this.allowOnlinePayment) {
        return null;
      }

      // Если у ученика статус Отказался/Завершён и у него не осталось долгов перед группой
      if (this.join.status === 'over' && !this.debtSubscriptions.length && !this.debtInvoices.length) {
        return null;
      }

      const cl = this.classes.find(c => c.id === this.join.classId);
      if (!cl) {
        return null;
      }

      const classPaymentEnabled = cl.onlinePayment && cl.onlinePayment.enabled;

      if (this.classPayType === 'lessons') {
        if (!classPaymentEnabled) {
          return null;
        }

        return ['join', this.join.id];
      }

      if (this.debtInvoices.length) {
        return ['invoice', this.debtInvoices[0].id];
      }

      if (this.join.price > this.join.stats.totalPayed) {
        if (!classPaymentEnabled) {
          return null;
        }

        return ['join', this.join.id];
      }

      return null;
    },
    ...mapGetters(['filials', 'classes', 'userSubscriptions', 'allowOnlinePayment', 'UISettings', 'lang', 'managers']),
  },
  methods: {
    getDebtColor(date) {
      if (!date) {
        return null;
      }
      const diff = -moment().diff(date, 'day');
      if (diff < 0) {
        return 'red lighten-4';
      }
      if (diff < 3) {
        return 'orange lighten-4';
      }
      return 'light-blue lighten-4';
    },
    showPaymentPanel(payFor, payObjectId) {
      this.setCreatePaymentDialog({
        payFor,
        payObjectId,
      });
    },
    ...mapMutations(['setCreatePaymentDialog']),
  },

};
</script>

<style scoped>

</style>
